const ModuleMyAuth = {
  namespaced: true,
  state: {
    username: '',
    idTokenRaw: '',
    accessTokenRaw: '',
    refreshTokenRaw: ''
  },
  mutations: {
    setAuthInfo (state, authInfo) {
      state.username = authInfo.username
      state.idTokenRaw = authInfo.idTokenRaw
      state.accessTokenRaw = authInfo.accessTokenRaw
      state.refreshTokenRaw = authInfo.refreshTokenRaw
    }
  }
}

export default ModuleMyAuth
